import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useProduct from "../../hooks/useProduct";
import ProductError from "../../components/product/Error/ProductError";
//import "./ProductPage.css";
import "./ProductPage1.css";
import ProductGallery from "../../components/product/Gallery/ProductGallery";
import ProductInfo from "../../components/product/ProductInfo/ProductInfo";
import ProductTitle from "../../components/product/ProductTitle/ProductTitle";
import ProductPrice from "../../components/product/ProductPrice/ProductPrice";
import VariationSelector from "../../components/product/VariationSelector/VariationSelector";
import QuantitySelector from "../../components/product/QuantitySelector/QuantitySelector";
import ProductBadges from "../../components/product/ProductBadges/ProductBadges";
import GiftModal from "../../components/product/GiftModal/GiftModal";
import ProductTabs from "../../components/product/ProductTabs/ProductTabs";
import ProductComments from "../../components/product/ProductComments/ProductComments";
import { useCart } from "../../context/CartContext";
import toast from "react-hot-toast";
import { validatePurchase } from "../../services/purchaseService";
import RelatedProducts from "../../components/product/RelatedProducts/RelatedProducts";
import RelatedArticles from "../../components/product/RelatedArticles/RelatedArticles";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import HomeContainer from "../../components/HomeContainer/HomeContainer";
import ProductPageSkeleton from "./ProductPageSkeleton";

export default function ProductPage() {
  const navigate = useNavigate();
  const { slug } = useParams();

  const { data, isLoading, isError, error } = useProduct(slug);

  const { addToCart, getCartItem, increaseQty, decreaseQty, isValidating } =
    useCart();

  const [availableGifts, setAvailableGifts] = useState([]);

  const [quantity, setQuantity] = useState(1);

  const [selectedVariation, setSelectedVariation] = useState(null);

  console.log("Query Data:", data);

  const isExpired = selectedVariation?.isExpired === true;

  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const [showGiftModal, setShowGiftModal] = useState(false);

  const [selectedGift, setSelectedGift] = useState(null);

  if (isLoading) {
    return <ProductPageSkeleton />;
  }

  if (isError) return <ProductError message={error.message} />;

  // const { product,variations,relatedProducts,articles,pictograms,} = data;

  // const product = data?.product;

  const variations = data?.variations ?? [];
  const relatedProducts = data?.relatedProducts ?? [];
  const articles = data?.articles ?? [];
  const pictograms = data?.pictograms ?? [];

  if (!data) return <ProductError message="Product not found" />;

  const { product, myComment, myRate, selectors, breadcrumb, loading } = data;

  //             const isIncreasing = isValidating(
  //     product.id,
  //     selectedVariation?.variationId
  // );

  const isQuantityLoading = isValidating(
    product.id,
    selectedVariation?.variationId,
  );

  //   const cartItem = selectedVariation
  //     ? getCartItem(product.id, selectedVariation.variationId)
  //     : null;

  const activeVariation =
    selectedVariation ??
    selectors
      ?.flatMap((selector) => selector.options)
      ?.find((option) => option.inStock);

  const hasDiscount =
    activeVariation?.salePrice != null &&
    activeVariation?.price != null &&
    Number(activeVariation.salePrice) < Number(activeVariation.price);

  const isProductAvailable =
    activeVariation &&
    activeVariation.inStock &&
    Number(activeVariation.quantity) > 0 &&
    !activeVariation.isExpired;

  const cartItem = activeVariation
    ? getCartItem(product.id, activeVariation.variationId)
    : null;

  const hasGift = (product.gifts?.length ?? 0) > 0;

  const requestedQuantity = Number(quantity);

  if (!Number.isInteger(requestedQuantity) || requestedQuantity < 1) {
    toast.error("تعداد محصول باید حداقل ۱ باشد.");
    return;
  }

  async function addCurrentProduct(variation, gift = null) {
    console.log("variation:", variation);

    const requestedQuantity = 1;

    if (!variation) {
      toast.error("لطفاً یک گزینه را انتخاب کنید.");
      return;
    }

    if (!variation.inStock || variation.quantity < 1) {
      toast.error("این محصول موجود نیست.");
      return;
    }

    try {
      setIsAddingToCart(true);

      const purchaseData = await validatePurchase({
        productId: product.id,
        variationId: variation.variationId,
        quantity: requestedQuantity,
        giftId: gift?.id ?? null,
      });

      console.log("purchaseData:", purchaseData);

      addToCart({
        ...product,

        selectedVariation: {
          variationId: purchaseData.variation.id,
          quantity: purchaseData.inventory.stock,
          price: purchaseData.price.original,
          salePrice: purchaseData.price.sale,
          finalPrice: purchaseData.price.final,
          isExpired: purchaseData.inventory.expired,
          inStock: purchaseData.inventory.inStock,
          attributes: purchaseData.variation.attributes ?? [],
        },

        selectedGift: gift,

        qty: requestedQuantity,
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message || "امکان افزودن محصول وجود ندارد.",
      );
    } finally {
      setIsAddingToCart(false);
    }
  }

  function handleBuyNow() {
    const variation =
      selectedVariation ??
      selectors
        ?.flatMap((selector) => selector.options)
        ?.find((option) => option.inStock);

    if (!variation) {
      toast.error("لطفا نوع محصول را انتخاب کنید");

      return;
    }

    if (hasGift) {
      setShowGiftModal(true);
      return;
    }

    const success = addCurrentProduct(variation);

    if (success) {
      navigate("/checkout");
    }
  }

  //   async function handleAddToCart() {
  //     const variation =
  //       selectedVariation ??
  //       selectors
  //         ?.flatMap((selector) => selector.options)
  //         ?.find((option) => option.inStock);

  //     if (!variation) {
  //       toast.error("این محصول موجود نیست.");
  //       return;
  //     }

  //     if (variation.isExpired) {
  //       toast.error("این محصول منقضی شده است.");
  //       return;
  //     }

  //     try {
  //       setIsAddingToCart(true);

  //       const purchaseData = await validatePurchase({
  //         productId: product.id,

  //         variationId: variation.variationId,

  //         quantity: 1,
  //       });

  //       const currentGifts = purchaseData.gifts ?? [];

  //       setAvailableGifts(currentGifts);

  //       // No current gifts
  //       if (currentGifts.length === 0) {
  //         await addCurrentProduct(variation, null);

  //         return;
  //       }

  //       // Current gifts exist
  //       setShowGiftModal(true);
  //     } catch (error) {
  //       toast.error(
  //         error.response?.data?.message || "امکان افزودن محصول وجود ندارد.",
  //       );
  //     } finally {
  //       setIsAddingToCart(false);
  //     }
  //   }

  async function handleAddToCart() {
    const variation =
      selectedVariation ??
      selectors
        ?.flatMap((selector) => selector.options)
        ?.find((option) => option.inStock);

    if (!variation) {
      toast.error("این محصول موجود نیست.");
      return;
    }

    if (variation.isExpired) {
      toast.error("این محصول منقضی شده است.");
      return;
    }

    try {
      setIsAddingToCart(true);

      const purchaseData = await validatePurchase({
        productId: product.id,
        variationId: variation.variationId,
        quantity: 1,
      });

      const currentGifts = purchaseData.gifts ?? [];

      setAvailableGifts(currentGifts);

      if (currentGifts.length === 0) {
        await addCurrentProduct(variation, null);

        return;
      }

      setShowGiftModal(true);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "امکان افزودن محصول وجود ندارد.",
      );
    } finally {
      setIsAddingToCart(false);
    }
  }

  console.log("data product", data);

  return (
    <div className="product-page">
      <Breadcrumbs items={breadcrumb} />

      {/* <div className="product-container"> */}
      <HomeContainer>
        <div className="product-layout">
          <div className="product-title-mobile">
            <ProductTitle
              product={product}
              selectors={selectors}
              selectedVariation={selectedVariation}
            />
          </div>

          <div className="product-gallery">
            <ProductGallery images={product.images} />
          </div>

          <div className="product-buy">
            <ProductTitle
              product={product}
              selectors={selectors}
              selectedVariation={selectedVariation}
            />

            <ProductPrice
              product={product}
              selectors={selectors}
              selectedVariation={selectedVariation}
            />

            <ProductBadges product={product} variation={selectedVariation} />

            <VariationSelector
              selectors={selectors}
              onVariationChange={(variation) => {
                setSelectedVariation(variation);

                // reset quantity when variation changes
                setQuantity(1);
              }}
            />

            {cartItem ? (
              <div className="cart-actions">
                <QuantitySelector
                  quantity={cartItem.qty}
                  //  maxQuantity={selectedVariation?.quantity ?? 1}
                  maxQuantity={activeVariation?.quantity ?? 1}
                  //   onIncrease={() =>
                  //     increaseQty(product.id, selectedVariation.variationId)
                  //   }
                  //   onDecrease={() =>
                  //     decreaseQty(product.id, selectedVariation.variationId)
                  //   }
                  onIncrease={() =>
                    increaseQty(product.id, activeVariation.variationId)
                  }
                  onDecrease={() =>
                    decreaseQty(product.id, activeVariation.variationId)
                  }
                  isLoading={isQuantityLoading}
                />

                <button
                  className="go-cart-btn"
                  onClick={() => navigate("/cart")}
                >
                  مشاهده سبد خرید
                </button>
              </div>
            ) : (
              <button
                disabled={isExpired || isAddingToCart}
                className="add-cart-btn"
                onClick={handleAddToCart}
              >
                {isAddingToCart
                  ? "در حال بررسی..."
                  : isExpired
                    ? "محصول منقضی شده"
                    : "افزودن به سبد خرید"}
              </button>
            )}

            {showGiftModal && (
              <GiftModal
                gifts={availableGifts}
                selectedGift={selectedGift}
                setSelectedGift={setSelectedGift}
                onClose={() => {
                  setSelectedGift(null);

                  setShowGiftModal(false);
                }}
                onConfirm={async () => {
                  const variation =
                    selectedVariation ??
                    selectors
                      ?.flatMap((selector) => selector.options)
                      ?.find((option) => option.inStock);

                  if (!variation) {
                    return;
                  }

                  await addCurrentProduct(variation, selectedGift);

                  setSelectedGift(null);

                  setShowGiftModal(false);
                }}
              />
            )}
          </div>

          <div className="product-info">
            {/* <ProductInfo
              product={product}
              selectedVariation={selectedVariation}
            /> */}

            <div className="attribute-title-page">
              <h3>ویژگی های محصول</h3>
            </div>

            <div
              className="product-attribute"
              dangerouslySetInnerHTML={{
                __html: product.attribute,
              }}
            />
          </div>



          {/* <div className="mobile-sticky-price">

            <div
              className={`mobile-sticky-price-content ${hasDiscount ? "" : "no-discount"
                }`}
            >

              <ProductPrice
                product={product}
                selectors={selectors}
                selectedVariation={selectedVariation}
              />

              {cartItem ? (
                <div className="mobile-cart-actions">

                  <QuantitySelector
                    quantity={cartItem.qty}
                    maxQuantity={activeVariation?.quantity ?? 1}
                    onIncrease={() =>
                      increaseQty(
                        product.id,
                        activeVariation.variationId
                      )
                    }
                    onDecrease={() =>
                      decreaseQty(
                        product.id,
                        activeVariation.variationId
                      )
                    }
                    isLoading={isQuantityLoading}
                  />

                  <button
                    className="mobile-go-cart-btn"
                    onClick={() => navigate("/cart")}
                  >
                    مشاهده سبد خرید
                  </button>

                </div>
              ) : (
                <button
                  disabled={isExpired || isAddingToCart}
                  className="mobile-add-cart-btn"
                  onClick={handleAddToCart}
                >
                  {isAddingToCart
                    ? "در حال بررسی..."
                    : isExpired
                      ? "محصول منقضی شده"
                      : "افزودن به سبد خرید"}
                </button>
              )}

            </div>

          </div> */}

          <div className="mobile-sticky-price">

            <div
              className={`mobile-sticky-price-content ${hasDiscount ? "" : "no-discount"
                }`}
            >

              <ProductPrice
                product={product}
                selectors={selectors}
                selectedVariation={selectedVariation}
              />

              {isProductAvailable && (
                cartItem ? (

                  <div className="mobile-cart-actions">

                    <QuantitySelector
                      quantity={cartItem.qty}
                      maxQuantity={activeVariation?.quantity ?? 1}
                      onIncrease={() =>
                        increaseQty(
                          product.id,
                          activeVariation.variationId
                        )
                      }
                      onDecrease={() =>
                        decreaseQty(
                          product.id,
                          activeVariation.variationId
                        )
                      }
                      isLoading={isQuantityLoading}
                    />

                    <button
                      className="mobile-go-cart-btn"
                      onClick={() => navigate("/cart")}
                    >
                      مشاهده سبد خرید
                    </button>

                  </div>

                ) : (

                  <button
                    disabled={isAddingToCart}
                    className="mobile-add-cart-btn"
                    onClick={handleAddToCart}
                  >
                    {isAddingToCart
                      ? "در حال بررسی..."
                      : "افزودن به سبد خرید"}
                  </button>

                )
              )}

            </div>

          </div>

        </div>

        <section>
          <ProductTabs
            tabs={product.tabs}

          //  selectedVariation={selectedVariation}
          />
        </section>

        <section>
          <ProductComments
            id={product.id}
            myComment={myComment}
            myRate={myRate}
            comments={product.comments}
            rating={product.rating}
            type="products"
          />
        </section>

        <section>
          <RelatedProducts
            products={relatedProducts}
            currentProductId={product.id}
          />
        </section>

        <section>
          <RelatedArticles articles={articles} />
        </section>

        {/* </div> */}
      </HomeContainer>
    </div>
  );
}
